import { ChangeEvent } from "react";
import { Popover } from "@snpjs/core";

import { TableFilterProps } from "./TableFilter.types";
import styles from "./TableFilter.module.scss";

type TimestampRange = [string, string];

const toInputValue = (value: string): string => value.replace(" ", "T").slice(0, 19);

export const TimestampFilterComponent: React.FC<TableFilterProps> = ({ value, onChange }) => {
  const [start, end] = (value as TimestampRange | undefined) ?? ["", ""];

  const updateRange = (index: 0 | 1, nextValue: string) => {
    const nextRange: TimestampRange = [start, end];
    nextRange[index] = nextValue;
    onChange(nextRange.every((timestamp) => timestamp === "") ? undefined : nextRange);
  };

  const content = (
    <div className={styles.timestampPopover}>
      <label className={styles.timestampField}>
        From
        <input
          className={styles.control}
          type="datetime-local"
          step="1"
          value={toInputValue(start)}
          onChange={(event: ChangeEvent<HTMLInputElement>) => updateRange(0, event.target.value)}
        />
      </label>
      <label className={styles.timestampField}>
        To
        <input
          className={styles.control}
          type="datetime-local"
          step="1"
          value={toInputValue(end)}
          onChange={(event: ChangeEvent<HTMLInputElement>) => updateRange(1, event.target.value)}
        />
      </label>
      {(start || end) && (
        <div className={styles.dateActions}>
          <button className={styles.clearButton} type="button" onClick={() => onChange(undefined)}>
            Clear
          </button>
        </div>
      )}
    </div>
  );

  const displayValue = (timestamp: string) => timestamp
    ? timestamp.replace("T", " ").slice(0, 19)
    : "YYYY-MM-DD HH:mm:ss";

  return (
    <Popover content={content} placement="bottom-start" usePortal={true}>
      <div className={styles.timestampRangeTarget}>
        <span className={styles.timestampTargetValue}>{displayValue(start)}</span>
        <span className={styles.dateRangeSeparator}>to</span>
        <span className={styles.timestampTargetValue}>{displayValue(end)}</span>
        {(start || end) && (
          <button
            className={styles.clearButton}
            type="button"
            aria-label="Clear timestamp range"
            onClick={(event) => {
              event.stopPropagation();
              onChange(undefined);
            }}
          >
            ×
          </button>
        )}
      </div>
    </Popover>
  );
};